module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T0KXiS/images/cover.jpg?1685327319830",
      "alt": "This image is the cover for the book Compulsion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Compulsion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The past always catches up with you. Max Newman should know—he’s been running from his ever since he dropped out of Uni and made a disastrous move to the seedier side of London. Now he’s returned to Brighton to lick his wounds. Though Max believes the club scene is better left behind him, one night he lets his friends drag him out dancing. And suddenly the simple life he’s tried to lead gets complicated.")]), _vm._v(" "), _c('p', [_vm._v("At Compulsion, the Medina Group’s newest hotspot, Max meets Seve Nunez, a member of the Medina management and a man used to taking what he wants. The sexual chemistry between Max and Seve immediately leads to an intimate encounter in the backyard of the club—just the kind of dangerous behavior Max tried to leave behind. Despite that, he can't help but crave more, and Seve seems just as eager.")]), _vm._v(" "), _c('p', [_vm._v("But Max soon suspects that Seve may not be the scrupulous businessman he claims. Max has seen the Medina Group at work before, and what he saw got a good friend killed. He's not sure what future he has with Seve, but he'll have to decide whether to trust in Seve’s innocence or keep running. The wrong choice could land them both in mortal danger.")]), _c('p', [_c('strong', [_vm._v("Winner of the Best Erotic category at Love Romances and More Golden Rose Awards 2013")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clare London\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0